import { useState } from "react";

import { CustomPopover } from "src/base-components/Popover";
import {
  SchemaTypeSelector,
  TypeOption,
} from "src/base-components/SchemaTypeSelector";
import { Select } from "src/base-components/Select";
import {
  PropertyDefinitionOutput,
  PropertyDefinitionOutputTypeEnum,
} from "src/clients/features-control";
import { Cardinality } from "src/entities/queries";
import { RelationIcon } from "src/eventsCatalogue/SchemaEditor/RelationIcons";
import { RelationshipPopoverContent } from "src/eventsCatalogue/SchemaEditor/RelationshipPopoverContent";

type PropertyTypeSelectorProps = {
  value: PropertyDefinitionOutputTypeEnum;
  property: PropertyDefinitionOutput;
  singularDisplayName: string;
  pluralDisplayName: string;
  schemaId?: string;
  relSchema: string | undefined;
  relationCardinality?: Cardinality;
};

export const PropertyTypeSelector: React.FC<PropertyTypeSelectorProps> = ({
  value,
  property,
  schemaId,
  relSchema,
  singularDisplayName,
  pluralDisplayName,
  relationCardinality = Cardinality.ONE,
}) => {
  const [open, setOpen] = useState(false);

  if (value === "relation" && property) {
    const displayName = property.display_name ?? property.type;
    return (
      <CustomPopover
        button={
          <SchemaTypeSelector
            options={[
              {
                key: value,
                value: (
                  <TypeOption
                    icon={
                      <RelationIcon
                        cardinality={relationCardinality}
                        size="xs"
                      />
                    }
                    label={relSchema ?? displayName}
                  />
                ),
              },
            ]}
            value={value}
            disabled
            fullWidth
          />
        }
        className="w-70"
        isOpen={open}
        wrapperClassName="w-full"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <RelationshipPopoverContent
          cardinality={relationCardinality}
          pluralDisplayName={pluralDisplayName}
          propertyDisplayName={displayName}
          relatedSchemaId={relSchema ?? ""}
          schemaId={schemaId}
          singularDisplayName={singularDisplayName}
        />
      </CustomPopover>
    );
  }

  return (
    <Select
      options={PROPERTY_TYPE_OPTIONS}
      placeholder="Select type"
      value={value}
      disabled
      fullWidth
    />
  );
};

const PROPERTY_TYPE_OPTIONS = Object.values(PropertyDefinitionOutputTypeEnum)
  // Relation is specific type, we add it on the go in component
  .filter((type) => type !== PropertyDefinitionOutputTypeEnum.RELATION)
  .map((type) => ({
    key: type,
    value: <TypeOption label={type} />,
  }));
